import useFirstOpen from 'src/hooks/useFirstOpen';
const FirstOpenManager = () => {
  useFirstOpen();
  return null;
};
export default FirstOpenManager;